export default [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: {
            pageTitle: 'Ana Sayfa',
            breadcrumb: [
                {
                    text: 'Ana Sayfa',
                    active: true,
                },
            ],
        },
    },
]
